import { render } from "./SpecialProgrammesFilter.vue?vue&type=template&id=15ffe902&ts=true"
import script from "./SpecialProgrammesFilter.ts?vue&type=script&lang=ts&external"
export * from "./SpecialProgrammesFilter.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__